
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'SliderResult',
  props: {
    mean: Number,
    min: Number,
    max: Number,
    median: Number,
    unit: String,
    total: Number,
  },
  methods: {}
});
